import i18n from 'i18nextInstance';

export const downloadHeaders = [{
    key: 'day',
    label: i18n.t('Fecha')
}, {
    key: 'from_time',
    label: i18n.t('Hora')
}, {
    key: 'to_time',
    label: i18n.t('Hasta')
}, {
    key: 'appointment_type_name',
    label: i18n.t('Tipo')
}, {
    key: 'doctor_last_name',
    label: i18n.t('Profesional')
}, {
    key: 'doctor_first_name',
    label: i18n.t('Nombre')
}, {
    key: 'patient_last_name',
    label: i18n.t('Paciente')
}, {
    key: 'patient_first_name',
    label: i18n.t('Nombre')
}, {
    key: 'patient_identification',
    label: i18n.t('Documento')
}, {
    key: 'medical_coverage',
    label: i18n.t('Cobertura')
}, {
    key: 'plan',
    label: i18n.t('Plan')
}, {
    key: 'health_insurance',
    label: i18n.t('Afiliado')
}, {
    key: 'patient_company_name',
    label: i18n.t('Empresa')
}, {
    key: 'specialties',
    label: i18n.t('Especialidad')
}, {
    key: 'payment_status',
    label: i18n.t('Pago')
}, {
    key: 'status',
    label: i18n.t('Estado')
}, {
    key: 'created_at_day',
    label: i18n.t('Creado el día')
}, {
    key: 'created_at_hour',
    label: i18n.t('Creado a la hora')
}, {
    key: 'overshift',
    label: i18n.t('Sobreturno')
}, {
    key: 'office_name',
    label: i18n.t('Consultorio')
}, {
    key: 'comment',
    label: i18n.t('Comentarios')
}, {
    key: 'admitted_at',
    label: i18n.t('Admitido')
}, {
    key: 'inroom_at',
    label: i18n.t('Ingresado')
}, {
    key: 'finalized_at',
    label: i18n.t('Finalizado')
}, {
    key: 'cancellation_reason',
    label: i18n.t('Razón de cancelación')
}, {
    key: 'user',
    label: i18n.t('Usuario')
}, {
    key: 'user_type',
    label: i18n.t('Tipo de usuario')
}];
